
const FullPageSpinner = () => {
  return (
    <div className="min-h-full h-full w-full flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-[#C5282F]"></div>
      </div>
  )
}

export default FullPageSpinner